module.exports = __webpack_public_path__ + "static/media/grad3.dc90cc4a.PNG";